import { Grid, Box, Typography, useTheme } from '@mui/material';

import Form from 'components/Form';
import { IFormValues } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues {
  disabled?: boolean;
}

const contents = [
  'Tôi xác nhận rằng bác sĩ đã giải thích:',
  'Tình trạng sức khỏe của tôi, lý do tại sao tôi cần được truyền máu. Tôi hiểu những rủi ro, kể cả những rủi ro cụ thể cho tôi.',
  'Các lựa chọn điều trị liên quan khác và các rủi ro liên quan của chúng.',
  'Tiên lượng của tôi và nguy cơ không được điều trị.',
  'Không có gì đảm bảo rằng việc điều trị sẽ cải thiện tình trạng của tôi mặc dù nó đã được thực hiện với sự chăm sóc phù hợp.',
  'Nếu có tình huống nguy hiểm đến tính mạng xảy ra trong quá trình điều trị, chúng sẽ được xử lý kịp thời.',
];

const checks = [
  {
    label: 'Đồng ý truyền máu các sản phẩm máu - sao chép bệnh nhân',
    key: 'consent.checked01',
  },
  {
    label: 'Hướng dẫn cho người dùng - Ai cần máu?',
    key: 'consent.checked02',
  },
  {
    label:
      'Truyền máu - Trả lời một số câu hỏi thông thường cho bạn và gia đình.',
    key: 'consent.checked03',
  },
  {
    label: 'Các thành phần trong máu - Hướng dẫn cho bệnh nhân.',
    key: 'consent.checked04',
  },
];

const contents2 = [
  'Tôi đã có thể đặt câu hỏi và nêu lên mối quan tâm với bác sĩ về tình trạng của tôi, phương pháp điều trị được đề xuất và những rủi ro của nó, và các lựa chọn điều trị của tôi.\n     Những câu hỏi và mối quan tâm của tôi đã được thảo luận và trả lời thỏa đáng.',
  'Tôi hiểu rằng tôi có quyền thay đổi ý kiến bất cứ lúc nào trước khi điều trị, kể cả sau khi tôi đã ký vào mẫu đơn này nhưng tốt nhất là sau khi thảo luận với bác sĩ của tôi.',
];

const FContents = (props: Props) => {
  const { disabled, getValues, setValue } = props;
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="F. Sự đồng ý của bệnh nhân" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '14px',
                  lineHeight: '30px',
                  whiteSpace: 'pre',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '30px',
                whiteSpace: 'pre-wrap',
              }}
            >
              • {v}
            </Typography>
          );
        })}
      </Box>
      <Box sx={{ width: '98%', margin: '0px auto 0px 15px' }}>
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '30px',
            whiteSpace: 'pre',
          }}
        >
          Tôi đã được cung cấp các bảng thông tin bệnh nhân sau đây;
        </Typography>
        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={12}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box sx={{ width: '98%', margin: '10px auto 24px auto' }}>
        {contents2.map((v, i) => {
          return (
            <Typography
              sx={{
                fontWeight: '500',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
                color: `${palette.primary.dark}`,
              }}
            >
              • {v}
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default FContents;
